<template>
  <div id="app">
    <keep-alive-router-view :cache="$route.meta.keepAlive" />
    <WxAuth ref="wxAuthRef" @success="wxAuthSuccess"></WxAuth>
  </div>
</template>

<script>
import WxAuth from '@/views/home/components/wxAuth.vue';
import HomeApi from '@/api/home';

export default {
  name: 'App',
  components: {
    WxAuth,
  },
  created() {
    const envType = this.$globalObj.getEnvType()
    // 卡尼调用
    if ((envType === 'FLUTTER_IOS' || envType === 'FLUTTER_ANDROID') &&
      !['mrsx', 'banbei'].includes(localStorage.getItem('appName'))) {
      this.getUserPersonalInfo();
    }
  },
  methods: {
    wxAuthSuccess() {
      const userInfo = JSON.parse(localStorage.getItem('userInfo'));
      if (userInfo) {
        userInfo.wechatAuth = 1; // 更新微信授权状态
        localStorage.setItem('userInfo', JSON.stringify(userInfo));
      }
    },
    async getUserPersonalInfo() {
      const res = await HomeApi.getUserPersonalInfo();
      localStorage.setItem('userInfo', JSON.stringify(res.data));

      if (res.data.wechatAuth === 0) {
        this.$refs.wxAuthRef.init();
      }
    },
  },
};
</script>
<style lang="scss">
* {
  padding: 0;
  margin: 0;
  font-size: 14px;
  list-style: none;
}
</style>
